import { Injectable, Injector } from "@angular/core";
import { Person } from "@common/ADAPT.Common.Model/person/person";
import { AdaptClientConfiguration } from "@common/configuration/adapt-client-configuration";
import { IdentityStorageService } from "@common/identity/identity-storage.service";
import { IUserEventHandler } from "@common/user/user-event-handler.interface";
import Clarity from "@microsoft/clarity";

@Injectable({
    providedIn: "root",
})
/**
 * Clarity resources here: https://clarity.microsoft.com/ and https://learn.microsoft.com/en-us/clarity
 * NPM instructions here: https://www.npmjs.com/package/@microsoft/clarity
 */
export class ClarityTracker implements IUserEventHandler {
    public constructor(
        private injector: Injector,
    ) {
        if (this.shouldTrack) {
            Clarity.init(AdaptClientConfiguration.AnalyticsProductId);
        }
    }

    public userChanged(person?: Person) {
        if (!this.shouldTrack) {
            return;
        }

        // identify the logged-in user for Clarity session replay lookup
        if (person && person.personId && this.identityStorageService.isLoggedIn) {
            Clarity.identify(this.identityStorageService.userName!, undefined, undefined, person.fullName);
            Clarity.setTag("personId", person.personId.toString());
        }
    }

    private get identityStorageService() {
        // This will throw an error if we try to inject in the constructor
        // Should be able to put it up there once the service is converted
        // to angular
        return this.injector.get(IdentityStorageService);
    }

    /**
     * Helper property to determine Whether this tracker should be activated or not.
     *
     * Note: We don't commonly record analytics for qa or dev environments, because the session count is extremely high and will use up our allowance very quickly.
     */
    private get shouldTrack() {
        return !!AdaptClientConfiguration.AnalyticsProductId;
    }
}
